module.exports = __webpack_public_path__ + "static/image4-7d3dd5f212ec4361fdd7b31808675604.png";